import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=fb30b45e&scoped=true&"
import script from "./FormPassword.vue?vue&type=script&lang=js&"
export * from "./FormPassword.vue?vue&type=script&lang=js&"
import style0 from "./FormPassword.vue?vue&type=style&index=0&id=fb30b45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb30b45e",
  null
  
)

export default component.exports